<template>
  <b-modal
    ref="my-modal"
    v-model="showModal"
    no-close-on-backdrop
    centered
    hide-footer
    title="Thông tin"
  >
    <template #modal-header="{}">
      <div class="w-100 d-flex justify-content-between align-items-center">
        <h5 class="d-inline-flex align-items-center mb-0">THÔNG TIN</h5>

        <div class="text-end">
          <b-button
            variant="outline-secondary"
            class="mr-1"
            @click="$emit('update:show-modal', false)"
          >
            Đóng
          </b-button>
          <b-button type="submit" @click="handleOk" variant="primary"
            >Lưu
          </b-button>
        </div>
      </div>
    </template>
    <validation-observer ref="simpleRules">
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group>
          <validation-provider #default="{ errors }" name="Mã" rules="required">
            <label style="font-size: 13px"
              >Mã <span style="color: red">*</span></label
            >
            <b-form-input
              v-model="model.code"
              :state="errors.length > 0 ? false : null"
              placeholder="Mã"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <b-form-group>
          <validation-provider
            #default="{ errors }"
            name="Mã quốc gia"
            rules="required"
          >
            <label style="font-size: 13px"
              >Mã quốc gia <span style="color: red">*</span></label
            >
            <b-form-input
              v-model="model.qgCode"
              :state="errors.length > 0 ? false : null"
              placeholder="Mã"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <b-form-group>
          <validation-provider
            #default="{ errors }"
            name="Tên"
            rules="required"
          >
            <label style="font-size: 13px"
              >Tên <span style="color: red">*</span></label
            >
            <b-form-input
              v-model="model.name"
              :state="errors.length > 0 ? false : null"
              placeholder="Tên"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <b-form-group>
          <validation-provider
            #default="{ errors }"
            name="description"
            rules=""
          >
            <label style="font-size: 13px">Mô tả</label>
            <b-form-input
              v-model="model.description"
              :state="errors.length > 0 ? false : null"
              placeholder="Mô tả"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </form>
    </validation-observer>
  </b-modal>
</template>

<script>
import { ref, watch } from "@vue/composition-api";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import { required, email, confirmed, password } from "@validations";
import LayoutData from "@/layouts/LayoutData";
import {
  BRow,
  BCol,
  BButton,
  BFormGroup,
  BFormInput,
  BModal,
  VBModal,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import BCardCode from "@core/components/b-card-code/BCardCode.vue";
import {
  CommonCreate as Create,
  CommonUpdate as Update,
} from "@/services/api/Common/CommonService";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import vi from "vee-validate/dist/locale/vi.json";
// import { response } from "express";

localize("vi", vi);

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BModal,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
    "b-modal": VBModal,
  },
  data() {
    return {};
  },
  props: ["showModal", "model", "reload", "nameController"],
  computed: {},
  created() {},
  methods: {
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // console.log("fdf", bvModalEvt);
      // Trigger submit handler
      this.handleSubmit();
    },
    handleSubmit() {
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          var postdata = {
            controller: this.nameController,
            data: this.model,
          };
          // console.log("id", this.model.id);
          if (this.model.id != 0 && this.model.id != null) {
            // Update
            Update(postdata).then((res) => {
              if (res.isError) {
                // console.log("ưewr");
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "Thất bại",
                    icon: "AlertTriangleIcon",
                    variant: "error",
                    text: res.message,
                  },
                });
              } else {
                this.$emit("update:show-modal", false);
                this.$emit("update:reload", !this.reload);
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "Thành công",
                    icon: "CheckIcon",
                    variant: "success",
                    text: res.message,
                  },
                });
              }
            });
          } else {
            // Create
            Create(postdata).then((res) => {
              if (res.isError) {
                // console.log("ưewr");
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "Thất bại",
                    icon: "AlertTriangleIcon",
                    variant: "error",
                    text: res.message,
                  },
                });
              } else {
                this.$emit("update:show-modal", false);
                this.$emit("update:reload", !this.reload);
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "Thành công",
                    icon: "CheckIcon",
                    variant: "success",
                    text: res.message,
                  },
                });
              }
            });
          }
        }
      });
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
